import "./src/styles/styles.scss"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
